module.exports = __webpack_public_path__ + "367dd7c7201cab04591dfa60373146d2.jpg";